exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.isMain[data-v-7a9de19b] {\n  font-weight: bold;\n}\n[data-v-7a9de19b] .v-list__tile{\n  height:32px;\n}\n[data-v-7a9de19b] .v-list__tile p{\n  margin-bottom:0;\n}\n", ""]);

// exports
